import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import FooterRow from './FooterRow';
import FooterCell from './FooterCell';
// eslint-disable-next-line import/named,import/no-cycle
import { TableContext } from '../../CustomTable';

export default function TableFooter({ margin = '0px', withExtraFooter = false, withActionController = false }) {
  const ctx = useContext(TableContext);

  return (
    <div style={{ width: '100%', marginTop: margin, padding: withExtraFooter ? '10px 13px' : '0 26px 20px 26px', ...(withExtraFooter ? ctx.extraFooterStyles : ctx.footerStyles) }}>
      <FooterRow>
        {ctx?.columns()?.map((column) => (
          <FooterCell key={column.id} alignment={column?.alignment}>
            {withExtraFooter ? column.extraFooter(ctx.data) : column.footer(ctx.data)}
            {withActionController && column.id === 'actions' && ctx?.actionControllerFooter && ctx.actionControllerFooter(ctx.data)}
          </FooterCell>
        ))}

      </FooterRow>
    </div>
  );
}
